import React from 'react'

const Description = ({ description, ...props }) => {
  if (!description) return null

  const formatParagraph = (text) => {
    // Escape HTML entities
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;')
  }

  const paragraphs = description
    .split(/\n/g)
    .filter((i) => i !== '\r' && i.trim() !== '')

  return (
    <div className='workout-information' {...props}>
      {paragraphs.map((para, index) => (
        <p key={index} dangerouslySetInnerHTML={{ __html: para }} />
      ))}
    </div>
  )
}

export default Description
